import { CrearLlamadoRequest, Llamado, LlamadoListado } from '../../models/Entities/Turnero';
import { ErrorType } from '../../models/HttpError';

export const TURNERO_LLAMADOS_CREAR_REQUEST = 'TURNERO-LLAMADOS_CREAR_REQUEST';
export const TURNERO_LLAMADOS_CREAR_SUCCESS = 'TURNERO-LLAMADOS_CREAR_SUCCESS';
export const TURNERO_LLAMADOS_CREAR_FAILURE = 'TURNERO-LLAMADOS_CREAR_FAILURE';

export interface TurneroLlamadosCrearRequestAction {
    type: typeof TURNERO_LLAMADOS_CREAR_REQUEST;
    payload: CrearLlamadoRequest;
}

export interface TurneroLlamadosCrearSuccessAction {
    type: typeof TURNERO_LLAMADOS_CREAR_SUCCESS;
    payload: Llamado;
}

export interface TurneroLlamadosCrearFailureAction {
    type: typeof TURNERO_LLAMADOS_CREAR_FAILURE;
    error: ErrorType;
}

export const TURNERO_LLAMADOS_GET_ULTIMOS_REQUEST = 'TURNERO-LLAMADOS_GET_ULTIMOS_REQUEST';
export const TURNERO_LLAMADOS_GET_ULTIMOS_SUCCESS = 'TURNERO-LLAMADOS_GET_ULTIMOS_SUCCESS';
export const TURNERO_LLAMADOS_GET_ULTIMOS_FAILURE = 'TURNERO-LLAMADOS_GET_ULTIMOS_FAILURE';

export interface TurneroLlamadosGetUltimosRequestAction {
    type: typeof TURNERO_LLAMADOS_GET_ULTIMOS_REQUEST;
    sectorId: number;
}

export interface TurneroLlamadosGetUltimosSuccessAction {
    type: typeof TURNERO_LLAMADOS_GET_ULTIMOS_SUCCESS;
    sectorId: number;
    payload: LlamadoListado[];
}

export interface TurneroLlamadosGetUltimosFailureAction {
    type: typeof TURNERO_LLAMADOS_GET_ULTIMOS_FAILURE;
    sectorId: number;
    error: ErrorType;
}

export const TURNERO_LLAMADOS_PURGE_OLD_REQUEST = 'TURNERO-LLAMADOS_PURGE_OLD_REQUEST';
export const TURNERO_LLAMADOS_PURGE_OLD_SUCCESS = 'TURNERO-LLAMADOS_PURGE_OLD_SUCCESS';
export const TURNERO_LLAMADOS_PURGE_OLD_FAILURE = 'TURNERO-LLAMADOS_PURGE_OLD_FAILURE';

export interface TurneroLlamadosPurgeOldRequestAction {
    type: typeof TURNERO_LLAMADOS_PURGE_OLD_REQUEST;
}

export interface TurneroLlamadosPurgeOldSuccessAction {
    type: typeof TURNERO_LLAMADOS_PURGE_OLD_SUCCESS;
    payload: number;
}

export interface TurneroLlamadosPurgeOldFailureAction {
    type: typeof TURNERO_LLAMADOS_PURGE_OLD_FAILURE;
    error: ErrorType;
}
